import {StyleSheet} from 'react-native';

export default StyleSheet.create({
    container: {
        flex: 1,
    },
    offerImg:{width:300,height:300,alignSelf:'center'},
    offerTitle:{
        fontFamily: 'Raleway',
        marginBottom: 4,
        marginTop:20,
        fontSize: 14,
        fontWeight: '600'
    },
    offerBody:{
        fontFamily: 'Raleway',
        fontWeight:'400',
        color:'#999999',
    },
    text: {
        marginLeft:15,
        fontFamily: 'Raleway'
    },
    shopNow: {
        borderWidth:1,
        borderStyle:"solid",
        paddingHorizontal:15,
        paddingVertical:7,
        textAlign:"center",
        maxWidth:200,
        alignSelf:"flex-end",
        fontFamily:'Raleway'
    },
});
